import React, { useContext, useEffect } from "react";
import HeaderComponent from "../../../components/header/header.component";
import { CasesProvider, GlobalContext } from "../../../store";
import { CommonService } from "../../../services/common/common.service";
import { useTranslation } from "react-i18next";
import AIDevelopmentContentComponent from "../../../modules/case/components/list/ai-development-content/ai-development-content.component";

const AIDevelopmentPage = () => {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.AI_SOFTWARE_DEVELOPMENT"));
      setPageTitle(t("PAGE_META_TITLES.AI_SOFTWARE_DEVELOPMENT"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CasesProvider>
      <HeaderComponent />
      <AIDevelopmentContentComponent />
    </CasesProvider>
  );
};

export default AIDevelopmentPage;
